export default {
  empMonitorCurrentTab: 0, //current tab,
  empMonitorSettingsSource: "settings",
};
